import React from 'react'
import Header from './components/header/Header'
import Navbar from './components/navbar/Navbar'
import { Outlet } from 'react-router-dom'

function RestaurantLayout() {
    return (
        <div>
            <div>
                <Header />
            </div>
            <div>
                <Navbar />
            </div>
            <div style={{padding:"20px 32px"}}>
                <Outlet/>
            </div>
        </div>
    )
}

export default RestaurantLayout